module.exports = __webpack_public_path__ + "static/img/appsMockupRight.47e0910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/appsMockupRight.png
// module id = Ds+o
// module chunks = 0